
import { Component, Prop } from 'vue-property-decorator';
import Button from '@/components/atoms/Button/Button.vue';
import segmentIo from '@/utils/segment.io';

@Component({})
export default class FilledButton extends Button {
  @Prop() trackClick?: boolean;

  constructor() {
    super();
  }

  onClick(): void {
    const params: any = {};
    if (!this.trackClick) return;

    if (this.$route.name) params['Route Name'] = this.$route.name;
    if (this.$el.id) params['Button Id'] = this.$el.id;
    if (this.$el.textContent) params.Label = this.$el.textContent.trim();
    if (this.$el.className) params.Class = this.$el.className.trim();
    if (this.$modal && this.$modal.visible && this.$modal.options)
      params['Modal Name'] = this.$modal.options.componentToRender;

    segmentIo.track('Clicked FilledButton Component', params);
  }
}
